import { render, staticRenderFns } from "./ProjectDetailNavigation.vue?vue&type=template&id=3f98b650&scoped=true&"
import script from "./ProjectDetailNavigation.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailNavigation.vue?vue&type=style&index=0&id=3f98b650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98b650",
  null
  
)

component.options.__file = "ProjectDetailNavigation.vue"
export default component.exports